<template>
  <div class="results">
    <div class="row" v-for="institution in institutions" :key="institution.id">
      <div class="col-md-5">
        <div class="institution-name">
          <img width="30" :src="institution.attributes.logoUrl" alt="institution logo" class="institution-logo"> <span>{{ institution.attributes.name }}</span>
        </div>
      </div>
      <div class="col-md-7">
        <div class="tags">
          <div class="institution-status">
            <span class="present" v-if="institution.attributes.status === 'experimental'">EXP</span>
          </div>
          <div class="account-information">
            <span class="present" v-if="institutionHasAccountInfo">AI</span>
          </div>
          <div class="institution-payments-enabled">
            <span class="present" v-if="institution.attributes.paymentsEnabled">PI</span>
          </div>
          <div class="institution-bulk-payments-enabled">
            <span class="present" v-if="institution.attributes.bulkPaymentsEnabled">BULK</span>
          </div>
          <div class="institution-country"><img width="20" :src="countryFlag(institution.attributes.country)" alt="Country Flag"> {{ institution.attributes.country ? institution.attributes.country : 'INT' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InstitutionsList',
    props: {
      institutions: {
        type: Array,
        required: true
      }
    },
    created() {
      this.$i18n.locale = this.getLanguageFromUrl();
    },
    methods: {
      countryFlag(country) {
        if (process.env.NODE_ENV === 'development') {
          if (country == null) {
            return require(`@/assets/svg/int.svg`);
          } else {
            return require(`@/assets/svg/${country.toLowerCase()}.svg`);
          }
        } else {
          if (country == null) {
            return "/wp-content/polylang/int.svg";
          } else {
            return "/wp-content/polylang/" + country.toLowerCase() + ".svg";
          }
        }
      },
      getLanguageFromUrl() {
        const pathSegments = window.location.pathname.split('/');
        const lang = pathSegments[1];
        return lang || 'en';
      },
    },
    computed: {
      institutionHasAccountInfo() {
        return true;
      },
      showExperimentalHeader() {
        return this.institutions.some(institution => institution.attributes.status === 'experimental');
      }
    }
  }
</script>